// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2086U","placeholdersHeader":"styles_placeholdersHeader__1VaTL","editorStyle":"styles_editorStyle__28ujF","placeholdersBox":"styles_placeholdersBox__30lAG"};